import { Icon } from "@iconify/react";
import { LoadingButton } from "@mui/lab";
import { Card, Container, Grid, Link, Typography } from "@mui/material";
import FileTable from "../../components/application-table/FileTable";
import { Img } from "../../components/styled";
import Page from "../../core/components/Page";
import useSettings from "../../hooks/useSettings";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const { themeStretch } = useSettings();
  const navigate = useNavigate();

  return (
    <Page title="Dosya Paneli | Boardnote">
      <Container maxWidth={themeStretch ? false : "xl"}>
        <Grid container spacing={3}>
          <Grid item sx={{ minWidth: "100%" }}>
            <Card sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item>
                  <Img
                    alt="illustration"
                    src="/illustrations/illustration_file.png"
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: 3 }} sm container>
                  <Grid item xs container direction="column">
                    <Grid item xs>
                      <Typography
                        gutterBottom
                        variant="subtitle1"
                        component="div"
                      >
                        Dosya Seçin
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Oluşturduğunuz ses dosyasını buradan yükleyiniz.
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Allowed *.mp4, *.mp3, *Max size of 50 MB
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <LoadingButton
                      variant="contained"
                      startIcon={<Icon icon="mdi:plus" />}
                      onClick={() => {
                        navigate("/dashboard/file/upload-audio");
                      }}
                    >
                      Ses Dosyası Yükle
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <FileTable />
        </Grid>
      </Container>
    </Page>
  );
}
